// MOCK: teks placeholder untuk meninjau UI. Judul dan jumlah bab belum dikunci (Library Spec bagian 19).
export const books = [
  {
    id: "membingkai-pertanyaan",
    category: { id: "Kerangka", en: "Framing" },
    title: { id: "Membingkai Pertanyaan", en: "Framing the Question" },
    summary: {
      id: "Cara menuliskan pertanyaan keputusan agar batasnya jelas sebelum opsi disebut.",
      en: "How to write a decision question so its boundary is clear before options are named.",
    },
    chapters: [
      {
        id: "b1",
        minutes: 6,
        tags: ["kerangka"],
        title: { id: "Pertanyaan, bukan tugas", en: "A question, not a task" },
        body: {
          id: [
            "Pertanyaan keputusan menanyakan apa yang harus dipilih. Tugas menyebut apa yang harus dikerjakan. Mencampur keduanya membuat opsi tampak sudah dipilih sebelum ada yang menimbangnya.",
            "Tulis pertanyaan dengan satu kata kerja pilihan: buka atau tahan, ganti atau pertahankan. Bila kalimat Anda diawali dengan kata kerja pelaksanaan, kemungkinan itu masih tugas.",
            "Periksa apakah pertanyaan menyebut jawabannya. Pertanyaan yang baik dapat dijawab dengan dua atau lebih cara yang sama-sama masuk akal.",
          ],
          en: [
            "A decision question asks what must be chosen. A task states what must be done. Mixing the two makes an option look chosen before anyone has weighed it.",
            "Write the question around one choosing verb: open or hold, replace or keep. If your sentence begins with an executing verb, it is probably still a task.",
            "Check whether the question names its own answer. A good question can be answered in two or more ways that are each reasonable.",
          ],
        },
      },
      {
        id: "b2",
        minutes: 5,
        tags: ["kerangka", "horizon"],
        title: { id: "Menentukan horizon", en: "Setting the horizon" },
        body: {
          id: [
            "Horizon adalah rentang waktu tempat keputusan ini diukur. Tanpa horizon, setiap fakta tampak relevan dan setiap risiko tampak mendesak.",
            "Pilih horizon yang sama dengan waktu Anda akan menilai hasilnya, bukan waktu keputusan diumumkan.",
            "Bila ragu antara dua horizon, tulis keduanya sebagai dua pertanyaan. Satu keputusan tidak perlu menjawab dua rentang sekaligus.",
          ],
          en: [
            "The horizon is the span of time over which this decision is measured. Without one, every fact looks relevant and every risk looks urgent.",
            "Choose the horizon in which you will judge the result, not the one in which the decision is announced.",
            "If two horizons compete, write them as two questions. One decision does not need to answer two spans at once.",
          ],
        },
      },
      {
        id: "b3",
        minutes: 4,
        tags: ["kerangka"],
        title: { id: "Batas yang tidak dinilai", en: "What is not judged" },
        body: {
          id: [
            "Sebut apa yang berada di luar pertanyaan. Batas yang tertulis menghemat waktu rapat karena perdebatan di luar batas dapat ditunda dengan sopan.",
            "Daftar singkat cukup. Tiga hal yang tidak dinilai lebih berguna daripada sepuluh hal yang dinilai setengah-setengah.",
            "Batas bukan opsi. Ia hanya menutup pintu yang memang bukan milik keputusan ini.",
          ],
          en: [
            "Name what sits outside the question. A written boundary saves meeting time because debate beyond it can be deferred politely.",
            "A short list is enough. Three things not judged are more useful than ten judged halfway.",
            "A boundary is not an option. It only closes doors that never belonged to this decision.",
          ],
        },
      },
    ],
  },
  {
    id: "membaca-asumsi",
    category: { id: "Praktik", en: "Practice" },
    title: { id: "Membaca Asumsi", en: "Reading Assumptions" },
    summary: {
      id: "Memisahkan apa yang diketahui, apa yang diandaikan, dan apa yang belum diketahui.",
      en: "Separating what is known, what is assumed, and what is not yet known.",
    },
    chapters: [
      {
        id: "a1",
        minutes: 5,
        tags: ["asumsi"],
        title: { id: "Tiga jenis kalimat", en: "Three kinds of sentence" },
        body: {
          id: [
            "Setiap kalimat dalam catatan keputusan termasuk salah satu dari tiga: sudah diketahui, diandaikan, atau belum diketahui. Kesulitan muncul ketika ketiganya ditulis dengan nada yang sama.",
            "Tanyakan pada tiap kalimat: dari mana saya tahu ini. Bila jawabannya adalah kebiasaan, itu asumsi.",
          ],
          en: [
            "Every sentence in a decision note is one of three: known, assumed, or not yet known. Trouble begins when all three are written in the same tone.",
            "Ask of each sentence: how do I know this. If the answer is habit, it is an assumption.",
          ],
        },
      },
      {
        id: "a2",
        minutes: 4,
        tags: ["asumsi", "unknown"],
        title: { id: "Menamai yang belum diketahui", en: "Naming the unknown" },
        body: {
          id: [
            "Yang belum diketahui paling mudah dilewatkan karena tidak meninggalkan kalimat. Tuliskan sebagai pertanyaan pendek agar ia tetap terlihat.",
            "Satu unknown yang terbuka sering lebih penting daripada tiga fakta tambahan.",
          ],
          en: [
            "The not-yet-known is easiest to skip because it leaves no sentence behind. Write it as a short question so it stays visible.",
            "One open unknown is often more important than three additional facts.",
          ],
        },
      },
    ],
  },
];

export const getBookData = (id) => books.find((b) => b.id === id);
